import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "./delhi-prefit.module.css";
//import csatWebBanner from "../../assets/images/upsc/delhi-scholarship-web-banner.webp";
//import csatMobBanner from "../../assets/images/upsc/delhi-scholarship-mobile.webp";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Form from "./form";
import check from "../../assets/images/upsc/check.png";


const TnpscWorkshop = () => {
    return (
        <>

            <Head>
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Delhi Prefit Scholarship Test</title>
                <meta name="title" content="Delhi Prefit Scholarship Test" />
                <meta name="description" content="Achieve UPSC success with top coaching at the Best IAS Academy in Chennai. Expert mentors, comprehensive curriculum, and proven results." />
                <link rel="canonical" href="www.shankariasacademy.com/sch-test" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Delhi Prefit Scholarship Test" />
                <meta property="og:description" content="Achieve UPSC success with top coaching at the Best IAS Academy in Chennai. Expert mentors, comprehensive curriculum, and proven results." />
                <meta property="og:url" content="www.shankariasacademy.com/sch-test" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

            <Navbar title="sch-test"/>

           {/* <div className="container">
                <div className='row pt-4 d-none d-md-block'>
                    <div className='col'>
                        <h1 className={`${styles.pagemaintitle}`}>Delhi Prefit Scholarship Test</h1>
                        <Image src={csatWebBanner} className="img-fluid w-100" alt="csat-plus" title="csat-plus" />
                    </div>
                </div>
                <div className='row pt-4 d-block d-md-none'>
                    <div className='col'>
                        <h1 className={`${styles.pagemaintitle}`}>Delhi Prefit Scholarship Test</h1>
                        <Image src={csatMobBanner} className="img-fluid w-100" alt="csat-plus" title="csat-plus" />
                    </div>
                </div>
            </div>*/}
            {/* <Form /> */}
{/* Registration closed form */}

<div className='container-fluid my-4 p-4' style={{ background:"lightgrey", opacity: "1", }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col'>
                            <p className={`${styles.regclose} text-center mb-0`}><span className={`${styles.bgregclose}`}>Registration Closed</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid' id={styles.bgimage}>
                <div className='container pt-3'>
                    <div className='row'>
                        <div className='col'>
                            <p className={`${styles.acheiverrank} text-center text-white mb-0`}>Scholarship Test on&nbsp;&nbsp;<span className={`${styles.acheiverranks1}`}>11th Feb 2024, 11:00 AM to 1:00 PM</span></p>
                            <p className={`${styles.acheiverrank} text-center text-white`}>For more details, contact&nbsp;&nbsp;<a href='tel:88991 80180 ' className={`${styles.acheiverranks1}`}>88991 80180 | 011-35611098</a></p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid"
                style={{ background: "transparent linear-gradient(180deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box", opacity: "1", }}>
                <div className="container">
                    <div className="row text-center">
                        <div className="col-xl-6 col-lg-8 col-md-10 mx-auto text-start mb-xl-5 mb-0">
                            <h2 className={`${styles.sectiontitle} pt-5`}>Test series - overview</h2>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />37 Half Test+ 13 Revision / Full tests and 3 UPSC mock tests</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />10 comprehensive CSAT tests</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />Recorded Discussion for each test</p>
                            <hr />
                        </div>


                        <div className="col-xl-6 col-lg-8 col-md-10 mx-auto  text-start mb-xl-5 mb-0">
                            <h2 className={`${styles.sectiontitle} pt-2 pt-md-5`}>Daily tests for 63 days!</h2>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />Write a test everyday morning</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />Complete a part of the syllabus daily</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />CSAT test every Saturday</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />Get performance analytics every day</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid mx-md-3 mx-2`} />Complete prelims syllabus in 3 months</p>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid py-4' style={{ backgroundColor: "#E2F6FF", border: "1px solid #D9DFE6" }}>
                <div className="container">
                    <div className="row py-3 justify-content-center justify-content-xl-start">
                        <div className="col-xl-4 col-lg-6 col-md-8 col-12 p-3" style={{ backgroundColor: "#FFFFFF" }}>
                            <h2 className={`${styles.sectiontitle} text-center`}>Test series - overview</h2>
                            <div className="row mx-auto pt-2">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverranks}`}>Rank</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverranks}`}>Scholarship percentage</p>
                                </div>
                                <hr></hr>
                            </div>

                            <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>1-10</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>100% scholarship</p>
                                </div>
                                <hr></hr>
                            </div>

                            <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>11-35</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>50% scholarship</p>
                                </div>
                                <hr></hr>
                            </div>

                            <div className="row mx-auto">
                                <div className="col ps-0">
                                    <p className={`${styles.acheiverrank}`}>36-60</p>
                                </div>
                                <div className="col">
                                    <p className={`${styles.acheiverrank}`}>25% scholarship</p>
                                </div>
                                <hr></hr>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default TnpscWorkshop;